/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressListModel } from '@well/address-management-domain-model';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TableRowAction } from '@irian-ro/util-table';
import { ActionType } from '@well/infra/constants';
import { LazyLoadEvent } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'well-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    TranslateModule,
    SelectModule,
    SharedComponentsModule,
    PrimengUtilsModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    TooltipModule,
    InputTextModule],
})
export class AddressListComponent implements OnInit {
  @Input() addresses: AddressListModel[] | undefined = undefined;
  @Input() addressType: string[] | undefined = undefined;
  @Input() totalSize: number | undefined = undefined;
  @Input() viewOnly = false;
  @Input() visibilityTypes: string[] | undefined = undefined;
  @Input() crmAddress = false;
  @Output() lazyLoadAddresses = new EventEmitter<LazyLoadEvent>(true);
  @Output() rowAction: EventEmitter<TableRowAction> = new EventEmitter<TableRowAction>(true);

  deleteUuid: string | undefined = undefined;
  showDialog = false;

  cols: any[] | undefined = undefined;

  ngOnInit() {
    this.cols = [
      { field: 'addressTypeValue', header: 'address.list.type', type: 'dropdown', filterMatchMode: 'equals' },
      { field: 'city', header: 'address.list.city', type: 'text' },
      { field: 'addressLine', header: 'address.list.addressLine', type: 'text' },
      { field: 'state', header: 'address.list.state', type: 'text' },
      { field: 'country', header: 'address.list.country', type: 'text' },
      { field: 'postalCode', header: 'address.list.postalCode', type: 'text' },
      { field: 'ownerCompanyName', header: 'address.list.ownerCompanyName', filterMatchMode: 'contains', type: 'text' },
      { field: 'companyName', header: 'address.list.companyName', filterMatchMode: 'contains', type: 'text' },
      { field: 'visibilityType', header: 'address.list.visibilityType', filterMatchMode: 'equals', type: 'dropdown' },
      { field: 'addressLabel', header: 'address.list.label', type: 'text' }
    ];
  }

  loadAddressesLazy(event: any) {
    this.lazyLoadAddresses.emit(event);
  }

  edit(uuid: string) {
    const action = {
      actionType: ActionType.EDIT,
      rowDataUuid: uuid,
    };
    this.rowAction.emit(action);
  }

  delete() {
    const action = {
      actionType: ActionType.DELETE,
      rowDataUuid: this.deleteUuid,
    };
    this.rowAction.emit(action);
    this.onHideDialog();
  }

  onShowDialog(uuid: string) {
    this.deleteUuid = uuid;
    this.showDialog = true;
  }

  onHideDialog() {
    this.showDialog = false;
  }
}
